import { users } from '@/store/typed/typed-modules';
import { TAccessType } from '../types';

export const getCurrentUser = () => users.getters.current();

export const getCurrentClient = () => users.getters.currentClient();

export const hasPermission = (
  moduleKey: string,
) => getCurrentUser()?.hasPermission(moduleKey) || false;

export const hasPermissionAccess = (
  moduleKey: string,
  accessType?: TAccessType,
  id?: string | number,
) => getCurrentUser()?.hasPermissionAccess(moduleKey, accessType, id) || false;

export const hasBuildingStackConnection = (): boolean => {
  const currentClient = getCurrentClient();
  return currentClient?.buildingStackClient?.status === 'enabled';
};

export const hasSecuredForms = (): boolean => {
  const currentUser = getCurrentUser();
  return currentUser?.getClientSettingValue('feature_secured_forms') === '1';
};
